export default {
  methods: {
    makeToast (type, title, msg) {
      if (this.$toastr === undefined) {
        return false
      }

      this.$toastr('add', {
        position: 'toast-top-full-width',
        type: type,
        title: title,
        msg: msg,
        clickClose: true,
        closeOnHover: false,
        timeout: 5000
      })
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/mixins/toast.js